(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define(
      'product-modal',
      class ProductModal extends ModalDialog {
        constructor() {
          super();
        }

        hide() {
          super.hide();
        }

        show(opener) {
          super.show(opener);
          this.showActiveMedia();
        }

        showActiveMedia() {
          this.querySelectorAll(
            `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
          ).forEach((element) => {
            element.classList.remove('active');
          });
          const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
          const activeMediaTemplate = activeMedia.querySelector('template');
          const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
          activeMedia.classList.add('active');
          activeMedia.scrollIntoView();

          const container = this.querySelector('[role="document"]');
          container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

          if (
            activeMedia.nodeName == 'DEFERRED-MEDIA' &&
            activeMediaContent &&
            activeMediaContent.querySelector('.js-youtube')
          )
            activeMedia.loadContent();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener(
        'change',
        debounce((event) => {
          const body = JSON.stringify({ note: event.target.value });
          fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
        }, 300)
      );
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(
        `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
      ).forEach((element) => {
        element.classList.remove('active');
      });
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMediaContent &&
        activeMediaContent.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wl-main-list-collections-grid"]) return;
  try {
    
  class WLCollectionGrid extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('.collection-list-item'));

      document.addEventListener('collection-list:filter', (event) => {
        this.applyFilter(event.detail.filter);
      });

      const params = new URLSearchParams(window.location.search);
      this.applyFilter(params.get('filter') || 'all');
    }

    applyFilter(filter) {
      this.items.forEach((item) => {
        if (filter === 'all') {
          item.classList.remove('is-hidden');
          return;
        }
        const tags = (item.dataset.tags || '')
          .split(',')
          .map((tag) => tag.trim())
          .filter(Boolean);
        item.classList.toggle('is-hidden', !tags.includes(filter));
      });

      // Filtering can shrink the page height (items are display:none).
      // DL_ScrollAction (assets/dl-common.js) caches each .dl-js-sa element's
      // top/bottom offset once at page load and only re-measures on window
      // resize, so it never notices this content-driven height change.
      // Without recomputing, its cached offset for the footer can end up
      // beyond the new (shorter) max scroll position, so .dl-footer__wrap
      // never gets "sa-active" and stays opacity:0. Re-running init() forces
      // it to remeasure against the current layout and re-check now.
      if (window.DL_ScrollActionInstance) {
        window.DL_ScrollActionInstance.init();
      }
    }
  }
  customElements.define('wl-collection-grid', WLCollectionGrid);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wl-main-list-collections-sidebar"]) return;
  try {
    
  class WLCollectionSidebar extends HTMLElement {
    constructor() {
      super();
      this.updateSidebarPosition = this.updateSidebarPosition.bind(this);
    }

    connectedCallback() {
      this.filterButtons = Array.from(this.querySelectorAll('[data-filter]'));
      this.filterSelect = this.querySelector('.collection-list-filter-mobile__select');
      this.sidebar = this.querySelector('.collection-list-sidebar');
      this.mainContent = document.getElementById('MainContent');
      this.grid = document.querySelector('.collection-list-grid');

      this.filterButtons.forEach((button) => {
        button.addEventListener('click', () => this.applyFilter(button.dataset.filter, true));
      });

      if (this.filterSelect) {
        this.filterSelect.addEventListener('change', () => this.applyFilter(this.filterSelect.value, true));
      }

      const params = new URLSearchParams(window.location.search);
      this.applyFilter(params.get('filter') || 'all', false);

      this.updateSidebarPosition();
      window.addEventListener('resize', this.updateSidebarPosition);
      window.addEventListener('scroll', this.updateSidebarPosition, { passive: true });
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.updateSidebarPosition);
      window.removeEventListener('scroll', this.updateSidebarPosition);
    }

    getHeaderHeight() {
      const header = document.querySelector('.section-header');
      if (header) return header.offsetHeight;
      const value = getComputedStyle(document.documentElement).getPropertyValue('--header-height');
      const parsed = parseInt(value, 10);
      return Number.isNaN(parsed) ? 60 : parsed;
    }

    updateSidebarPosition() {
      if (!this.sidebar) return;

      const isDesktop = window.matchMedia('(min-width: 990px)').matches;

      if (!isDesktop) {
        if (this.spacer) {
          this.spacer.remove();
          this.spacer = null;
        }
        this.sidebar.style.position = '';
        this.sidebar.style.top = '';
        this.sidebar.style.left = '';
        this.sidebar.style.width = '';
        if (this.mainContent) this.mainContent.style.minHeight = '';
        return;
      }

      if (!this.spacer) {
        this.spacer = document.createElement('div');
        this.spacer.className = 'collection-list-sidebar-spacer';
        this.sidebar.after(this.spacer);
      }

      const spacerRect = this.spacer.getBoundingClientRect();
      this.sidebar.style.width = `${spacerRect.width}px`;

      const headerHeight = this.getHeaderHeight();
      const sidebarHeight = this.sidebar.offsetHeight;

      // Document-relative Y where the grid starts (constant regardless of scroll
      // position), used both to line the sidebar up with the grid's first row and to
      // tell whether the page has actually been scrolled down past that point yet.
      let gridDocTop = headerHeight;
      if (this.mainContent) {
        const mainRect = this.mainContent.getBoundingClientRect();
        const mainPaddingTop = parseFloat(getComputedStyle(this.mainContent).paddingTop) || 0;
        gridDocTop = mainRect.top + window.scrollY + mainPaddingTop;

        // A filtered-out grid (few or zero matching products) can leave #MainContent's
        // natural height shorter than the fixed sidebar itself. Since the footer sits
        // immediately after #MainContent, that shrinks it up the page and it ends up
        // behind/overlapping the sidebar. Force #MainContent to stay at least tall
        // enough to contain the full sidebar so the footer never rides up over it.
        // (min-height only raises the floor -- a normal, taller grid is unaffected.)
        // Use a modest fixed gap here rather than the full (180px) section-bottom
        // padding -- that padding is sized for the normal, content-filled case, and
        // reusing it after a short/empty grid left a noticeably oversized empty gap.
        const sidebarBottomGap = 40;
        this.mainContent.style.minHeight = `${mainPaddingTop + sidebarHeight + sidebarBottomGap}px`;
      }

      // A fixed sidebar keeps the same viewport position forever, so once the page
      // scrolls past the bottom of the collection grid, it starts overlapping the
      // footer (or floating over the section's trailing whitespace). Once the grid's
      // bottom edge reaches it, drop the fixed behavior and pin the sidebar's bottom
      // to the grid's bottom instead, so it lines up with the right column and then
      // scrolls away together with the footer rather than covering it.
      // This only makes sense once we've actually scrolled past the grid's top --
      // otherwise a short filtered result (fewer items than the sidebar is tall) would
      // trip this the moment the page loads, even though nothing has been scrolled.
      const hasScrolledPastGridTop = window.scrollY > Math.max(gridDocTop - headerHeight, 0);

      if (this.grid && this.mainContent && hasScrolledPastGridTop) {
        const gridRect = this.grid.getBoundingClientRect();
        const reachedGridBottom = gridRect.bottom <= headerHeight + sidebarHeight;

        if (reachedGridBottom) {
          // Once absolute, the containing block switches from the viewport (fixed)
          // to #MainContent, so "left" has to be re-expressed relative to it too.
          const mainRect = this.mainContent.getBoundingClientRect();
          const top = Math.max(this.grid.offsetTop + this.grid.offsetHeight - sidebarHeight, 0);
          this.sidebar.style.position = 'absolute';
          this.sidebar.style.left = `${spacerRect.left - mainRect.left}px`;
          this.sidebar.style.top = `${top}px`;
          return;
        }
      }

      // Line the sidebar up so it starts at the same height as the grid's first row,
      // instead of just under the header, so "Collections" and the first collection
      // image sit level with each other.
      this.sidebar.style.position = 'fixed';
      this.sidebar.style.left = `${spacerRect.left}px`;
      this.sidebar.style.top = `${Math.max(gridDocTop, headerHeight)}px`;
    }

    applyFilter(filter, updateUrl) {
      const matchedButton =
        this.filterButtons.find((button) => button.dataset.filter === filter) ||
        this.filterButtons.find((button) => button.dataset.filter === 'all');
      const activeFilter = matchedButton ? matchedButton.dataset.filter : 'all';

      this.filterButtons.forEach((button) => {
        button.classList.toggle('is-active', button === matchedButton);
      });

      if (this.filterSelect) {
        this.filterSelect.value = activeFilter;
      }

      document.dispatchEvent(
        new CustomEvent('collection-list:filter', {
          detail: {
            filter: activeFilter,
          },
        })
      );

      // The grid's height (and so #MainContent's min-height requirement) changes
      // immediately once filtering hides/shows items -- recompute right away rather
      // than waiting for the next scroll/resize event.
      this.updateSidebarPosition();

      if (updateUrl) {
        const url = new URL(window.location.href);
        if (activeFilter === 'all') {
          url.searchParams.delete('filter');
        } else {
          url.searchParams.set('filter', activeFilter);
        }
        window.history.replaceState({}, '', url);

        // Scrolling down and then filtering to a small result set can make it look like
        // there are almost no matching products, so bring the page back to the top of
        // the section whenever a filter is applied.
        if (this.mainContent) {
          const top = this.mainContent.getBoundingClientRect().top + window.scrollY - this.getHeaderHeight();
          window.scrollTo({ top, behavior: 'smooth' });
        }
      }
    }
  }
  customElements.define('wl-collection-sidebar', WLCollectionSidebar);

  } catch(e) { console.error(e); }
})();
})();
